module.exports = "/images/satellite.png?f2be0f3e65a895c5b50dff15336b9d72";